
import {
  ref,
  watch,
  computed,
  defineComponent,
} from 'vue';

import ParticularsModal from '../modal/particulars.vue';

import { useStore, } from 'vuex';
import { useRouter, useRoute, } from 'vue-router';

import {
  DatePicker,
  ConfigProvider,
  Input,
  Table,
  Pagination,
  Button,
  Select,
} from 'ant-design-vue';
import moment, { Moment, } from 'moment';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import { ColumnProps, } from 'ant-design-vue/es/table/interface';

import { allTicketTypeList, ticketStatus, } from '@/configs/index';

type Key = ColumnProps['key'];

const { RangePicker, } = DatePicker;
const { Option, } = Select;

type PaginationType = {
  current: number;
  pageSize: number;
};

type FilterType = {
  name: string;
  address: string;
};

type ColumnType = {
  title: string;
  dataIndex?: string;
  slots?: any;
  filters?: {
    text: string;
    value: string;
    children?: {
      text: string;
      value: string;
    }[];
  }[];
  width?: any;
  onFilter?: (value: string, record: any) => boolean;
  sorter?: any;
  sortDirections?: string[];
  showSorterTooltip?: any;
  defaultSortOrder?: string;
  filterMultiple?: string[] | boolean;
};

// 列表行配置
const columns: ColumnType[] = [
  {
    title: '序号',
    slots: { customRender: 'index', },
    width: '4%',
  },
  {
    title: '工单编号',
    dataIndex: 'orderCode',
  },
  {
    title: '工单标题',
    dataIndex: 'title',
  },
  {
    title: '工单类型',
    dataIndex: 'type',
    slots: { customRender: 'type', },
    width: '8%',
  },
  {
    title: '创建类型',
    dataIndex: 'orderType',
    slots: { customRender: 'orderType', },
    width: '8%',
  },
  {
    title: '创建时间',
    dataIndex: 'createDate',
    defaultSortOrder: 'descend',
    sorter: true,
    sortDirections: ['descend',
      'ascend',
      'descend',],
    showSorterTooltip: false,
    width: '10%',
  },
  {
    title: '处理单位',
    dataIndex: 'companyName',
  },
  {
    title: '处理人',
    dataIndex: 'userName',
    width: '8%',
  },
  {
    title: '工单状态',
    dataIndex: 'status',
    slots: { customRender: 'status', },
    width: '8%',
  },
  {
    title: '处理时长(时)',
    dataIndex: 'acceptProcess',
    slots: { customRender: 'acceptProcess', },
    width: '8%',
  },
  {
    title: '操作',
    dataIndex: 'status',
    slots: { customRender: 'op', },
    width: '5%',
  },
];

export default defineComponent({
  components: {
    RangePicker,
    ConfigProvider,
    Input,
    Table,
    Button,
    ParticularsModal,
    Select,
    Option,
  },
  props: {
    isfull: {
      type: Boolean,
      default: () => false,
    },
    isList: {
      type: Boolean,
      default: () => true,
    },
  },
  emits: ['update:isfull', 'update:isList',],
  setup (props, context) {
    const store = useStore();
    const grantTicktTypeList = computed(() => store.state.userCenter.grantTicktTypeList);
    // id选择框
    const customId = ref<string>('');
    const orderType = ref<any>(-1);

    const curCustomDate = computed(() => store.state.ticket.customDate);
    // 日期选择框
    const customDate = ref<Moment[]>([moment(curCustomDate.value[0]),moment(curCustomDate.value[1]),]);
    // 状态选择
    const checkBox = ref<any>([]);
    // 表格数据
    const tableData = ref<any>([]);
    // 是否满屏
    const y = ref<number>(0);
    // 创建弹窗显隐
    const particularsVisible = ref<boolean>(false);

    const duplicateList = computed(() => store.state.ticket.duplicateList);
    const refresh = computed(() => store.state.ticket.refresh);
    const userInfo = computed(() => store.state.login.userInfo);

    checkBox.value = [
      {
        title: ticketStatus[0].title,
        value: ticketStatus[0].value,
        seleted: true,
        iconfont: 'icon-ticket-status-1',
      },
      {
        title: ticketStatus[1].title,
        value: ticketStatus[1].value,
        seleted: true,
        iconfont: 'icon-ticket-status-2',
      },
      {
        title: ticketStatus[2].title,
        value: ticketStatus[2].value,
        seleted: true,
        iconfont: 'icon-ticket-status-3',
      },
      {
        title: ticketStatus[3].title,
        value: ticketStatus[3].value,
        seleted: true,
        iconfont: 'icon-ticket-status-5',
      },
      {
        title: ticketStatus[4].title,
        value: ticketStatus[4].value,
        seleted: true,
        iconfont: 'icon-ticket-status-6',
      },
    ];

    const orderTypeList = ['placeholder',
      '自动',
      '手动',];

    const onChange = (value: Moment[], dateString: string[]) => {
      customDate.value = value;
    };

    const curSorter = ref<any>({ order: 'descend', });
    const current = ref<number>(1);
    const total = ref<number>(0);
    const route = useRoute();

    const currentOrder = route.query.id;

    const dataType = ref<any>(userInfo.value.dataType ?? 'allData');

    const getList = (page:number) => {
      if (currentOrder) {
        customId.value = currentOrder as string;
        customDate.value = [];
      }
      const selectStatus = checkBox.value.reduce((ans:any,cur:any,idx:number) => (cur.seleted ?
        [...ans,idx + 1,] :
        [...ans,]),[]);

      store.dispatch('ticket/changeCurRecord', {});
      store.dispatch('ticket/selectDuplicateList', {
        sort: curSorter.value.order === 'ascend' ?
          '' :
          '1',
        pageNo: page ?? 1,
        pageSize: 10,
        userId: userInfo.value.id,
        startDate: customDate.value[0] ? moment(customDate.value[0]).format('YYYY-MM-DD') : '',
        endDate: customDate.value[1] ? moment(customDate.value[1]).format('YYYY-MM-DD') : '',
        orderCode: customId.value,
        typeList: orderType.value > -1 ? [orderType.value,] : null,
        statusList: selectStatus.length ?
          selectStatus :
          [8,],
        selectType: '1',
        duplicateId: userInfo.value.id,
      });
    };

    const downList = () => {
      const selectStatus = checkBox.value.reduce((ans:any,cur:any,idx:number) => (cur.seleted ?
        [...ans,idx + 1,] :
        [...ans,]),[]);

      store.dispatch('ticket/downloadRepairOrderList', {
        sort: curSorter.value.order === 'ascend' ?
          '' :
          '1',
        userId: userInfo.value.id,
        startDate: moment(customDate.value[0]).format('YYYY-MM-DD'),
        endDate: moment(customDate.value[1]).format('YYYY-MM-DD'),
        orderCode: customId.value,
        typeList: orderType.value > -1 ? [orderType.value,] : null,
        statusList: selectStatus.length ?
          selectStatus :
          [8,],
      });
    };

    const onTableChange = (
      pagination: PaginationType,
      filters: FilterType[],
      sorter: ColumnType
    ) => {
      const sorte:any = sorter;

      if (curSorter.value?.order !== sorte?.order) {
        curSorter.value = sorter;
        getList(1);
      }
    };

    const rowSelection = {
      onChange: (selectedRowKeys: Key[], selectedRows: any[]) => {
        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      getCheckboxProps: (record: any) => ({
        disabled: record.name === 'Disabled User',
        name: record.name,
      }),
    };

    const table = ref<any>(null);

    const changeHeight = () => {
      context.emit('update:isfull', !props.isfull);
    };

    const selectOrderCode = ref<string>('');
    const particularsModalRef = ref();
    const action = ref<string>('');

    const showParticularsModal = (record: any, curAction: any | null) => {
      particularsVisible.value = true;
      selectOrderCode.value = record.id;
      particularsModalRef.value.getDetail(record.id);
      action.value = curAction;
    };

    const changeBlock = () => {
      context.emit('update:isList', !props.isList);
      showParticularsModal({}, 'created');
    };

    watch(duplicateList, (val) => {
      current.value = val.pageNum;
      total.value = val.total;
      tableData.value = val.list;
    });

    const orderCode = ref<any>('');

    watch(
      () => props.isList,
      (val, prevVal) => {
        if (val && !prevVal) {
          store.dispatch('ticket/changeLocation', { });
          getList(1);
        }
      }
    );

    watch(refresh, (val,oldVal) => {
      if (val !== oldVal) {
        particularsVisible.value = false;
        getList(1);
      }
    });

    const changeBox = (index: number) => {
      checkBox.value = checkBox.value.map((cur: any, idx: number) => {
        if (index === idx) {
          return { ...cur, seleted: !cur.seleted, };
        }

        return cur;
      });
      getList(1);
    };
    const paginationChange = (page:any, pageSize:any) => {
      current.value = page;
      getList(page);
    };

    const search = () => {
      getList(1);
    };

    const del = (cur: any) => {
      const params = {
        repairOrderId: cur.id,
      };

      store.dispatch('ticket/delOrder', params);
    };

    const delCancle = (e: MouseEvent) => {
      // console.log(e);

      // message.error('Click on No');
    };

    const curRecord = computed(() => store.state.ticket.curRecord);

    const rowClick = (record:any, index:any) => ({
      style: {
        'background-color': curRecord.value.id === record.id ?
          '#e6f7ff' :
          '#fff',
        color: curRecord.value.id === record.id ?
          '#111111' :
          '#000',
      },
      onClick: (event:any) => {
        // console.log(record);
        store.dispatch('ticket/changeCurRecord', record);
      },
    });

    return {
      userInfo,
      table,
      orderCode,
      current,
      total,
      zhCN,
      allTicketTypeList,
      grantTicktTypeList,
      orderTypeList,
      ticketStatus,
      customDate,
      customId,
      orderType,
      columns,
      tableData,
      Button,
      Pagination,
      checkBox,
      y,
      onChange,
      changeBox,
      onTableChange,
      changeHeight,
      rowSelection,
      search,
      changeBlock,
      getList,
      rowClick,
      paginationChange,
      particularsVisible,
      downList,
      action,
      store,
      dataType,
      selectOrderCode,
      particularsModalRef,
      showParticularsModal,

      del,
      delCancle,
    };
  },
  mounted () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that: any = this;
    const router = useRouter();
    const { status = '1,2,3,4,5,6,7', dateSelect = '', }: any =
      router.currentRoute.value.query;

    const selectStatus = status.split(',');

    that.checkBox = this.checkBox.map((cur:any,idx:number) => (selectStatus.includes(`${cur.value}`) ?
      { ...cur,seleted: true, } :
      { ...cur,seleted: false, }));
    if (dateSelect !== '') {
      const dates = dateSelect.split(',');

      that.customDate = dates.map((cur: any) => moment(cur));
    }

    that.getList(1);

    that.y = that.$refs.table.clientHeight - 104;

    window.onresize = () => {
      that.y = that.$refs.table.clientHeight - 104;
    };
  },
});
